import { render, staticRenderFns } from "./adjustmentFee.vue?vue&type=template&id=83ba98c8&scoped=true"
import script from "./adjustmentFee.vue?vue&type=script&lang=js"
export * from "./adjustmentFee.vue?vue&type=script&lang=js"
import style0 from "./adjustmentFee.vue?vue&type=style&index=0&id=83ba98c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba98c8",
  null
  
)

export default component.exports